import request from '@/utils/request'

// Delivery List By Period
export function getDeliList(param) {
    let data = param
    return request({
        url: `/delivery/epms5020/getDeliList`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function getDeliListXls(param) {
    let data = param
    return request({
        url: `/delivery/epms5020/getDeliListXls`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}